/* TODO: Удалить строки с игнорированием TS в задаче PUB-4351 (Исправить ошибки типизации) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { pipe } from '@/utils/pipe'


export function processGroupsAndUsers(groupsAndUsers) {
  /* Раскладываем группы и пользователей по двум словарям:
     1. По id. Каждая группа и пользователь добавляется однократно (пользователей,
      состоящих в нескольких группах, добавляем с первой из почтовых групп, в которой они состоят).
     2. По uid. Пользователи, состоящие в нескольких группах, добавляются несколько раз с каждой из групп,
      в которой состоят.
  */
  const itemsById: any = {}
  const itemsByUid: any = {}

  let pos = 0
  const adminGroups: any[] = []

  const addUser = (
    user,
    group = null, /* closure refs: itemsById, itemsByUid, pos */
  ) => {
    user.pos = pos++
    user.isUser = true
    user.children = []
    user.uid = globalThis.crypto.randomUUID()

    if (!itemsById[user.id]) {
      itemsById[user.id] = { ...user, track: group
        ? [0, group.id]
        : [0] }
    }

    itemsByUid[user.uid] = { ...user, track: group
      ? [0, group.uid]
      : [0] }
  }

  groupsAndUsers?.groups_with_users?.forEach((item) => {
    if (!item.users.length) {
      return
    }

    item.track = [0]
    item.pos = pos++
    item.isGroup = true
    item.id = item.id + 'G'
    item.uid = globalThis.crypto.randomUUID()

    // Административные группы не добавляем, но собираем отдельно и берем из них только тех пользователей,
    // которые не состоят ни в одной из почтовых групп.
    if (item.is_mail) {
      item.users.forEach(({ user }) => addUser(user, item))
      const childrenById = [...item.users.map((user) => user.user.id)]
      const childrenByUid = [...item.users.map((user) => user.user.uid)]
      delete item.users
      itemsById[item.id] = { ...item, children: childrenById }
      itemsByUid[item.uid] = { ...item, children: childrenByUid }
    } else {
      adminGroups.push(item)
    }
  })

  adminGroups.forEach((item) =>
    item.users.forEach(({ user }) => {
      if (!(user.id in itemsById)) {
        addUser(user)
      }
    }),
  )

  groupsAndUsers?.users_not_in_groups?.forEach((user) => addUser(user))

  return { itemsById, itemsByUid }
}

export function normalizeChildrenByTrack(items) {
  Object.keys(items).forEach((id) => {
    if (!isNaN(id)) {
      id = parseInt(id)
    }

    if (items[id]?.track && items[id].track.length > 1) {
      const parent = items[items[id].track[items[id].track.length - 1]]
      if (parent) {
        if (!parent.children) {
          parent.children = []
        }

        if (!parent.children.includes(id)) {
          parent.children.push(id)
        }
      }
    }
  })

  return items
}

export function makeItems(
  item: any,
  childrenField = 'children',
  idField = 'id',
  items = {},
  parent = null,
  pos = 0,
) {
  if (!item[idField]) {
    item[idField] = globalThis.crypto.randomUUID()
  }
  // if (!item.uid) item.uid = globalThis.crypto.randomUUID()
  items[item[idField]] = item
  if (parent) {
    item.track = [...parent.track]
    // item.track.push(parent.id)
    item.track.push(parent[idField])
  } else {
    item.track = []
  }
  item.pos = pos++
  if (item[childrenField]) {
    item[childrenField].forEach((childItem) => {
      makeItems(childItem, childrenField, idField, items, item, pos++)
    })
    item[childrenField] = item.children.map((child) => child[idField])
  }
  return items
}

function walkCodes(
  code: any,
  idField = 'id',
  items = {},
  parent = null,
  pos = 0,
) {
  return makeItems(code, 'children', idField, items, parent, pos)
}

function makeCodeItems(idField: string, code: any) {
  return walkCodes(code, idField)
}

export function processCodes(codes: any[] | any, idField = 'id') {
  if (Array.isArray(codes)) {
    codes = codes.reduce(
      (acc, cur) => {
        acc.children.push(cur)
        return acc
      },
      {
        id: '-1',
        children: [],
        path: '000000000000000000',
        pos: -1,
        uid: globalThis.crypto.randomUUID(),
      },
    )
  }
  return pipe(
    makeCodeItems.bind(null, idField),
    normalizeChildrenByTrack,
  )({ ...codes })
}
